import useEditCharacterAdj from '../composables/useEditCharacterAdj'
//------------------------------
// adj category to function map
//------------------------------
// const adjCategoryMap = {
//   characteristic: useEditCharacterAdj,
// }
//-----------------------------
// adj subject to category map
//-----------------------------
// const adjSubjectMap = {
//   characteristic: 'character_characteristic',
//   ability: 'ability',
// }
//--------------------------------------
// update character adjustments harness
//--------------------------------------
export default async function useUpdateCharacterAdjsHarness(changed_adjs) {
  console.log('------------------------')
  console.log('IN useUpdateCharacterAdjsHarness')
  console.log(
    '[RECOVERABLE_ARTEFACT_TRACE] useUpdateCharacterAdjsHarness batch',
    (changed_adjs || []).map((adj) => ({
      category: adj?.category ?? null,
      name: adj?.name ?? null,
      action: adj?.action ?? null,
      id: adj?.id ?? adj?.payload?.id ?? null,
      character_item: adj?.payload?.character_item ?? adj?.character_item ?? null,
      applied: adj?.payload?.applied ?? adj?.applied ?? null,
      adj_reason: adj?.payload?.adj_reason ?? adj?.adj_reason ?? null,
      adj_value: adj?.payload?.adj_value ?? adj?.adj_value ?? null,
    })),
  )
  //-----------------------------------------------------------------------
  // manages all character adj updates (CRUD) e.g. characteristic, ability
  //-----------------------------------------------------------------------
  //-------------------------------------
  // create promise for each adjs update
  //-------------------------------------
  const promises = changed_adjs.map((e) => {
    console.log('IN useUpdateCharacterAdjsHarness - PROCESSING ADJ:', e)

    // console.log('CLEAN e:', window.$deepCopy(e))
    //---------------------------------------
    // get appropriate function for category
    //---------------------------------------
    // const fn = adjCategoryMap[e.category]
    //-------------------------------------------------------------------------
    // rename adj subject id prop for category (where exists i.e. new records)
    //-------------------------------------------------------------------------
    // const subjectIdProp = adjSubjectMap[e.category]
    // if (subjectIdProp) {
    //   e.payload[subjectIdProp] = e.payload.adj_subject_id
    //   delete e.payload.adj_subject_id
    // }
    // console.log('CLEAN UPDATED e:', window.$deepCopy(e))
    //-----------------------------------------------
    // remove any remaining null values from payload
    //-----------------------------------------------
    if (e.payload) {
      Object.keys(e.payload).forEach((key) => {
        if (e.payload[key] === null) {
          delete e.payload[key]
        }
      })
    }
    //--------------------------------
    // call api function for category
    //--------------------------------
    // if (!fn) throw new Error(`Unknown category: ${e.category}`)
    // return fn(e)
    return useEditCharacterAdj(e)
  })
  //----------------------------------------------------------------------------
  // returns single promise once all updates complete - let errors propagate up
  //----------------------------------------------------------------------------
  return Promise.all(promises)
}
